import { Skeleton, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { DetailCard } from 'src/components/summary/DetailCard';
import { SummaryGrid } from 'src/components/summary/SummaryGrid';
import { SummaryValue } from 'src/components/summary/SummaryValue';
import { INSTALLATION_FIELDS } from 'src/features/detailSections/summaryFields';
import { useApplication } from 'src/hooks/applications';
import { getCatalogGenerationStatusLabel } from 'src/utils/enums/catalogGenerationStatus';
import { getCustomerEnvironmentApplicationSourceLabel } from 'src/utils/enums/customerEnvironmentApplicationSource';

const AppGeneralSection = () => {
  const { appId } = useParams();
  const { isLoading, data: app } = useApplication({ applicationId: appId });

  if (isLoading || !app) {
    return <Skeleton variant="rounded" height={180} sx={{ bgcolor: '#484848' }} />;
  }

  return (
    <Stack spacing={2}>
      <DetailCard compact>
        <SummaryGrid compact>
          <SummaryValue label="Files" compact>
            {(app.filesCount ?? 0).toLocaleString()}
          </SummaryValue>
          <SummaryValue label="Source" compact>
            {getCustomerEnvironmentApplicationSourceLabel(app.source)}
          </SummaryValue>
          <SummaryValue label="Catalog Generation" compact>
            {app.catalogGenerationStatus
              ? getCatalogGenerationStatusLabel(app.catalogGenerationStatus)
              : null}
          </SummaryValue>
        </SummaryGrid>
      </DetailCard>

      <DetailCard compact>
        <Stack spacing={2}>
          <Typography variant="subtitle2">Installation Details</Typography>
          <SummaryGrid compact>
            {INSTALLATION_FIELDS.map(field => (
              <SummaryValue key={field.label} label={field.label} compact>
                {field.read(app)}
              </SummaryValue>
            ))}
          </SummaryGrid>
        </Stack>
      </DetailCard>
    </Stack>
  );
};

export default AppGeneralSection;
